import { render, staticRenderFns } from "./TicketViewSidebar.vue?vue&type=template&id=0cf00e24&"
import script from "./TicketViewSidebar.vue?vue&type=script&lang=js&"
export * from "./TicketViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TicketViewSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TicketViewSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports